export const BREAKPOINTS = {
  iPhoneSE: 320,
  iPhonePro: 390,
  mobile: 480,
  tablet: 768,
  desktop: 1024
} as const;

export const FONT_SIZES = {
  iPhoneSE: 12,    // Minimum size for smallest screens
  iPhonePro: 13,   // Adjusted default size for iPhone Pro/12
  mobile: 14,      // Default mobile size
  tablet: 16,      // Comfortable tablet size
  desktop: 18      // Standard desktop size
} as const;

export const FONT_SIZE_CONTROLS = {
  MIN: {
    mobile: 10,    // Lowered minimum for more flexibility
    tablet: 12,    // Lowered for more size options
    desktop: 14    // Adjusted minimum for desktop
  },
  MAX: {
    mobile: 18,
    tablet: 22,
    desktop: 26
  },
  DEFAULT: {
    mobile: 13,    // Adjusted to match iPhone Pro
    tablet: 16,
    desktop: 18
  },
  STEP: {
    mobile: 1,
    tablet: 2,
    desktop: 2
  }
} as const;